import React from "react";
import { UserDocument } from "../../models/UserDocument";
import { DocumentIcon } from "./DocumentIcon";
import { RenderPdf } from "./ViewUserDocument";
import { ZoomIn } from "@mui/icons-material";

interface Props {
  document?: UserDocument;
  documentSrc?: string;
  style?: any;
  showZoomIcon?: boolean,
}

/**
 * If the document has a thumbnail go get it and display it,
 *  otherwise show a backup icon
 *
 * @param document
 * @constructor
 */
export const DocumentThumbnail = ({
  document,
  documentSrc,
  style,
  showZoomIcon,
}: Props): JSX.Element => {
  const zoomies = <ZoomIn color="primary" fontSize="large" style={{ border: "1px solid gray", position: "absolute", top: 2, left: 2, borderRadius: "5px", padding: "2px", zIndex: 1, backgroundColor: "white" }} />

  if (documentSrc && document?.version?.ext?.toLowerCase() === "pdf") {
    const pdf = <RenderPdf
      documentSrc={documentSrc + "#toolbar=0&scrollbar=0"}
      style={{
        pointerEvents: "none",
        minWidth: "0",
        minHeight: "0",
        overflow: "hidden",
        ...style,
      }}
    />
    return showZoomIcon ? <span style={{ position: "relative" }}>
      {zoomies}
      {pdf}
    </span> : pdf
  } else if (documentSrc) {
    const image = <img
      src={documentSrc}
      alt={document?.version?.title}
      title={document?.version?.title}
      style={{
        borderRadius: "10px",
        border: "1px inset",
        maxWidth: "100%",
        ...style,
      }}
    />
    return showZoomIcon ? <span style={{ position: "relative" }}>
      {zoomies}
      {image}
    </span> : image
  }

  return (
    <DocumentIcon
      title={document?.version?.title}
      extension={document?.version?.ext}
    />
  );
};
